const footer = [
	{
		key: 1,
		url: 'https://developer.mercedes-benz.com/legal/imprint',
		value: 'imprint'
	},
	{
		key: 2,
		url: 'https://developer.mercedes-benz.com/legal/notice',
		value: 'legalNotice'
	},
	{
		key: 3,
		url: '/legal/privacy',
		value: 'privacyStatement'
	},
	{
		key: 4,
		url: '/legal/cookies',
		value: 'cookies'
	},
];

export default footer;
